/**
 * AskExpertButton — small chip that opens the Ask-Expert modal.
 *
 * Drop-in on any lesson page, course page, forum reply, or comment.
 * Pass optional `context` so the AI answer is aware of where the user
 * was reading when they asked.
 *
 * Props:
 *   context?: { type, id, title, snippet }
 *   variant?: 'chip' | 'ghost' | 'block'
 *   className?: string
 */
import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import AskExpertModal from './AskExpertModal';

const AskExpertButton = ({ context, variant = 'chip', className = '', label = 'Ask an Expert' }) => {
  const [open, setOpen] = useState(false);

  const base = 'inline-flex items-center gap-1.5 font-bold transition-colors focus:outline-none';
  const styles = {
    chip:  'text-xs rounded-full border border-primary/30 bg-primary/10 text-primary hover:bg-primary/20 px-3 py-1.5',
    ghost: 'text-xs text-primary hover:underline',
    block: 'text-sm rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 px-4 py-2',
  };

  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className={`${base} ${styles[variant] || styles.chip} ${className}`}
        data-testid="ask-expert-btn"
      >
        <Sparkles className="w-3.5 h-3.5" />
        {label}
      </button>
      <AskExpertModal open={open} onClose={() => setOpen(false)} context={context} />
    </>
  );
};

export default AskExpertButton;
